/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_DescriptionInputs */

const en_plan_upgrade_description = /** @type {(inputs: Plan_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to a plan that fits your needs.`)
};

const es_plan_upgrade_description = /** @type {(inputs: Plan_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia a un plan que se adapte a tus necesidades.`)
};

/**
* | output |
* | --- |
* | "Switch to a plan that fits your needs." |
*
* @param {Plan_Upgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_description = /** @type {((inputs?: Plan_Upgrade_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_upgrade_description(inputs)
	return en_plan_upgrade_description(inputs)
});